export const TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS';
export const RESET_API_ERRORS = 'RESET_API_ERRORS';

export function tooManyRequestsAction(data) {
	return { type: TOO_MANY_REQUESTS, data };
}

export function resetApiErrorAction() {
	return { type: RESET_API_ERRORS };
}
